const en = {
  // Common
  "common.loading": "Loading...",
  "common.error": "An error occurred",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.delete": "Delete",
  "common.edit": "Edit",
  "common.back": "Back",
  "common.logout": "Sign Out",
  "common.submit": "Submit",
  "common.search": "Search",
  "common.noData": "No data found",
  "common.retry": "Try Again",
  "common.close": "Close",
  "common.more": "More",
  "common.open_app": "Open App",

  // Auth
  "auth.login": "Sign In",
  "auth.register": "Sign Up",
  "auth.logout": "Sign Out",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.confirm_password": "Confirm Password",
  "auth.username": "Username",
  "auth.display_name": "Full Name",
  "auth.forgot_password": "Forgot password?",
  "auth.no_account": "Don't have an account?",
  "auth.has_account": "Already have an account?",
  "auth.google_login": "Continue with Google",
  "auth.login_success": "Signed in successfully",
  "auth.register_success": "Account created successfully",
  "auth.logout_success": "Signed out",
  "auth.verify_email": "Verify Email",
  "auth.otp_sent": "A verification code was sent to your email",
  "auth.enter_otp": "Enter 6-digit code",
  "auth.resend_otp": "Resend Code",
  "auth.otp_verified": "Email verified!",

  // Navigation
  "nav.feed": "Feed",
  "nav.lifemap": "My Life",
  "nav.ai": "AI",
  "nav.calendar": "Calendar",
  "nav.new_post": "New",
  "nav.video": "Video Diary",
  "nav.challenges": "Challenges",
  "nav.highlights": "Highlights",
  "nav.journal": "Journal",
  "nav.analytics": "Analytics",
  "nav.search": "Search",
  "nav.notifications": "Notifications",
  "nav.settings": "Settings",
  "nav.galaxy": "Life Galaxy",
  "nav.profile": "Profile",
  "nav.other": "More",

  // Feed
  "feed.title": "Feed",
  "feed.no_posts": "No posts yet",
  "feed.load_more": "Load more",
  "feed.create_first": "Write your first post",

  // Post
  "post.create": "Create Post",
  "post.title": "Title (optional)",
  "post.body": "What happened today? Write your thoughts...",
  "post.date": "Date",
  "post.mood": "Mood",
  "post.privacy": "Visibility",
  "post.tags": "Tags",
  "post.location": "Location",
  "post.media": "Add Photos/Videos",
  "post.add_tag": "Add tag",
  "post.save": "Save",
  "post.delete": "Delete Post",
  "post.delete_confirm": "Are you sure you want to delete this post?",
  "post.saved": "Entry saved! ✨",
  "post.deleted": "Post deleted",
  "post.view_day": "View Day",
  "post.comments": "Comments",
  "post.no_comments": "No comments yet. Be the first! 💬",
  "post.add_comment": "Write a comment...",
  "post.comment_added": "Comment added",
  "post.reaction_failed": "Failed to react",

  // Privacy options
  "privacy.public": "Everyone",
  "privacy.friends": "Friends",
  "privacy.private": "Only Me",

  // Mood options
  "mood.great": "Great",
  "mood.good": "Good",
  "mood.neutral": "Neutral",
  "mood.bad": "Bad",
  "mood.terrible": "Terrible",

  // Calendar
  "calendar.title": "Life Calendar",
  "calendar.year": "Year",
  "calendar.today": "Today",
  "calendar.this_day": "This Day in History",
  "calendar.no_entries": "No entries for this day",
  "calendar.view_day": "View Day",
  "calendar.days_active": "Active Days",
  "calendar.total_posts": "Total Posts",

  // Analytics
  "analytics.title": "Life Analytics",
  "analytics.period.week": "Week",
  "analytics.period.month": "Month",
  "analytics.period.year": "Year",
  "analytics.mood_trends": "Mood Trends",
  "analytics.activity": "Activity",
  "analytics.growth": "Growth",

  // Profile
  "profile.title": "Profile",
  "profile.edit": "Edit Profile",
  "profile.posts": "Posts",
  "profile.friends": "Friends",
  "profile.add_friend": "Add Friend",
  "profile.request_sent": "Request Sent",
  "profile.bio": "Bio",
  "profile.location": "Location",
  "profile.website": "Website",
  "profile.joined": "Joined",

  // Settings
  "settings.title": "Settings",
  "settings.profile": "Profile",
  "settings.security": "Security",
  "settings.notifications": "Notifications",
  "settings.language": "Language",
  "settings.language.select": "Select Language",
  "settings.language.uz": "Uzbek",
  "settings.language.ru": "Russian",
  "settings.language.en": "English",
  "settings.save_profile": "Save Profile",
  "settings.change_password": "Change Password",
  "settings.current_password": "Current Password",
  "settings.new_password": "New Password",
  "settings.delete_account": "Delete Account",
  "settings.profile_saved": "Profile saved",
  "settings.password_changed": "Password changed",

  // Search
  "search.title": "Search",
  "search.placeholder": "Search users...",
  "search.no_results": "No results found",

  // Notifications
  "notifications.title": "Notifications",
  "notifications.empty": "No notifications",
  "notifications.mark_all_read": "Mark all as read",

  // Video
  "video.title": "Video Diary",
  "video.upload": "Upload Video",
  "video.no_videos": "No videos yet",
  "video.uploading": "Uploading...",

  // Challenges
  "challenges.title": "Challenges",
  "challenges.join": "Join",
  "challenges.active": "Active",
  "challenges.completed": "Completed",

  // Highlights
  "highlights.title": "Highlights",
  "highlights.create": "Create Highlight",
  "highlights.empty": "No highlights yet",

  // Journal
  "journal.title": "Journal",
  "journal.new_entry": "New Entry",
  "journal.no_entries": "No entries yet",

  // Errors
  "error.network": "Network error. Check your connection.",
  "error.unauthorized": "Authentication required",
  "error.not_found": "Page not found",
  "error.server": "Server error. Try again later.",
  "error.login_failed": "Invalid email or password",
  "error.register_failed": "Registration failed",

  // Days of week
  "day.mon": "Mon",
  "day.tue": "Tue",
  "day.wed": "Wed",
  "day.thu": "Thu",
  "day.fri": "Fri",
  "day.sat": "Sat",
  "day.sun": "Sun",

  // Months
  "month.1": "January",
  "month.2": "February",
  "month.3": "March",
  "month.4": "April",
  "month.5": "May",
  "month.6": "June",
  "month.7": "July",
  "month.8": "August",
  "month.9": "September",
  "month.10": "October",
  "month.11": "November",
  "month.12": "December",
};

export default en;
